import { render, staticRenderFns } from "./DialogChangeUserMultiplePosts.vue?vue&type=template&id=4cab8176&"
import script from "./DialogChangeUserMultiplePosts.vue?vue&type=script&lang=js&"
export * from "./DialogChangeUserMultiplePosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports